import { axiosClient } from './axiosClient.service'

const VALID_STATUS_CODE = 200
const BANNED_STATUS_CODE = 1011

export function onUserBanned(cb: (error: unknown) => void) {
  axiosClient.interceptors.response.use(
    (response) => {
      const { status, data } = response
      if (status === VALID_STATUS_CODE) {
        if ('error' in data && data.error.code === BANNED_STATUS_CODE) {
          cb(data.error)
        }
      }
      return response
    },
    (error) => error,
  )
}
